export enum Local {
  Global,
  US
}
